import { lazy } from 'react';
import reducer from './state/reducers';
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const TrainingCategoryList = lazy(() =>
    import('./TrainingCategoryList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if(auth.isAuthenticated) {
            store.injectReducer('trainingCategoryList', reducer.listReducer);
            return module;
        }
    })
);

const TrainingCategoryRoutes = [
    {
        label: 'Training Category',
        path: '/HRAutomation/TrainingCategory',
        menuName: 'hrAutomation',
        component: TrainingCategoryList,
        icon: 'fa-list',
        exact: true,
        showNav: true, 
        public: true, 
    },
]

export default TrainingCategoryRoutes;